import { TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { FieldHookConfig, useField } from 'formik';

/**
 * Objet qui permet d'avoir les props de formik plus les attributs que le veut custom
 */
type MyInputProps = FieldHookConfig<string> & {
    required?: boolean;
    id: string;
    label?: any;
    name: string;
    type?: string;
    maxDate?: string;
    tooltipMessage?: JSX.Element | null;
    handleChange?: any;
    InputProps?: any;
    autoComplete?: string;
    multiline?: boolean;
    maxRows?: number;
    maxLength?: number;
    rows?: number;
    disabled?: boolean;
    placeholder?: string;
    accept?: string;
    allowedRegex?: RegExp;
    step?: string;
    pattern?: string;
    inputMode?: 'search' | 'text' | 'none' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal';
};

/**
 * Composant select
 * @param props MyInputProps
 * @constructor
 */
export default function InputForm(props: MyInputProps) {
    const [field, meta] = useField(props);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    /**
     * Méthode qui permet de vérifier les entrées claviers sur le onChange
     * Utile pour le numéro de téléphone
     * @param event
     */
    function handleCheckInputValue(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        let isValid = true;
        //Pour le téléphone on valide que l'on rentre bien que des caractères numérique
        if (props.type === 'tel') {
            const reg = new RegExp(/^\d+$/);
            isValid = reg.test(event?.target?.value);
        }
        // Validation par regex générique
        if (props.allowedRegex) {
            isValid = props.allowedRegex.test(event?.target?.value);
        }
        //Code pour handlerCahnge spécifique
        if ((isValid || !event?.target?.value) && props.handleChange) {
            props.handleChange(event);
        }
        (isValid || !event?.target?.value) && field.onChange(event);
    }

    //Création du champ input
    const input = (
        <TextField
            {...field}
            required={props.required}
            id={props.id}
            label={props.label}
            name={props.name}
            type={props.type}
            fullWidth
            data-testid={props.id}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && Boolean(meta.error) && meta.error}
            inputProps={{
                max: props.type === 'date' ? props.maxDate : undefined,
                maxLength: props.maxLength,
                placeholder: props.placeholder ? props.placeholder : undefined,
                accept: props.accept ? props.accept : undefined,
                inputMode: props.inputMode,
                step: props.step,
                pattern: props.pattern,
            }}
            InputLabelProps={{ shrink: props.type === 'date' || props.type === 'file' ? true : undefined }}
            InputProps={props.InputProps}
            onChange={event => handleCheckInputValue(event)}
            autoComplete={props.autoComplete}
            multiline={props.multiline}
            maxRows={props.maxRows}
            rows={props.rows}
            disabled={props.disabled}
            placeholder={props.placeholder}
        ></TextField>
    );
    //On retourne le composant
    //Soit avec un tooltip si demandé sinon juste le input
    //Sur mobile, on affiche l'infobulle en permanence sous le champ
    if (props.tooltipMessage) {
        if (isMobile) {
            return (
                <>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {props.tooltipMessage}
                    </Typography>
                    {input}
                </>
            );
        }
        return (
            <Tooltip title={props.tooltipMessage} arrow>
                {input}
            </Tooltip>
        );
    }
    return input;
}
